import { Directive, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApiService } from '../services/api.service';

@Directive({
  selector: '[appEventTracker]',
  standalone: true,
})
export class EventTrackerDirective {
  @Input() appEventTracker = '';
  @Input() module = '';
  @Input() eventAction = '';
  @Input() trackingData: Record<string, unknown> = {};
  @Input() trackInput = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private apiService: ApiService,
  ) {}

  @HostListener('click')
  onClick(): void {
    this.logPayload();
  }

  @HostListener('input')
  onInput(): void {
    if (this.trackInput) this.logPayload();
  }

  @HostListener('change')
  onChange(): void {
    if (this.trackInput) this.logPayload();
  }

  private logPayload(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const hostname = window.location.hostname;
    const allowedDomains = ['www.atmavaan.com', 'atmavaan.com'];
    
    if (!allowedDomains.includes(hostname)) {
      return; 
    }
    
    const referrer = document.referrer;
    const loggedInUser = this.getLoggedInUser();
    const payload = {
      timestamp: new Date().toISOString(),
      module: this.module || 'unknown',
      eventAction: this.eventAction || 'click',
      page_title: document.title,
      url: location.pathname,
      referrer,
      isOrganic: this.isOrganicVisit(referrer),
      visitor_id: localStorage.getItem('visitorId') || 'anonymous',
      user_id: this.getLoggedInUserId(loggedInUser),
      user_name: loggedInUser?.user_name || '',
      user_email: loggedInUser?.email_id || loggedInUser?.email || '',
      eventData: { elementId: this.appEventTracker || 'unknown', ...this.trackingData },
    };

    this.apiService.logEvent(payload).subscribe({ error: () => {} });
  }

  private getLoggedInUser(): any {
    try {
      const raw = localStorage.getItem('user');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  // The stored 'user' object's id field name isn't consistent across every
  // login path in this codebase (name/email already get the same defensive
  // multi-key treatment elsewhere, e.g. chatbot-widget.ts) — try every
  // convention seen in this app rather than betting on one and silently
  // storing an empty user_id like before.
  private getLoggedInUserId(loggedInUser: any): string {
    const id = loggedInUser?.id ?? loggedInUser?.user_id ?? loggedInUser?._id ?? loggedInUser?.customer_id ?? loggedInUser?.userId;
    return id != null ? String(id) : '';
  }

  private isOrganicVisit(referrer: string): boolean {
    if (!referrer) return false;
    return ['google.', 'bing.', 'yahoo.', 'duckduckgo.', 'baidu.', 'yandex.'].some((domain) =>
      referrer.includes(domain)
    );
  }
}
